import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent {
  @Input() servicesTitle: string = '';

  constructor(private router: Router) {}

  isNotificacoesPage(): boolean {
    return this.router.url === '/notificacoes';
  }

}
